// extracted by mini-css-extract-plugin
export default {"headerWrapper":"styles_headerWrapper__Q9dUq","logoText":"styles_logoText__ePmfb","logoSubtext":"styles_logoSubtext__nQUyB","telefon":"styles_telefon__sixKZ"};